import { Link } from 'react-router-dom';

const sectors = [
  {
    id: 'real-estate',
    title: 'Premium Real Estate',
    subtitle: 'Strategic property investments across prime European and North American markets',
    icon: 'ri-building-4-line',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20glass%20skyscraper%20skyline%20at%20golden%20sunset%2C%20premium%20commercial%20real%20estate%2C%20reflective%20windows%2C%20professional%20architectural%20photography%2C%20warm%20amber%20and%20golden%20tones%2C%20bright%20and%20clean%20aesthetic%2C%20investment%20portfolio&width=1200&height=600&seq=sectors-hero-realestate-001&orientation=landscape',
    overview: 'Our real estate portfolio targets prime commercial and residential properties in gateway cities across Europe and North America. We focus on assets with strong cash flows, value-add potential, and strategic locations. From Class-A office towers in Geneva to logistics hubs in Paris, each acquisition is underwritten with UK precision and managed for long-term appreciation.',
    stats: [
      { value: '€1.1B', label: 'Portfolio Value' },
      { value: '32', label: 'Properties' },
      { value: '94%', label: 'Occupancy Rate' },
      { value: '14.2%', label: 'Avg Annual Return' },
    ],
    highlights: [
      'Class-A commercial towers in Geneva, Zurich, Berlin, and Paris',
      'Last-mile logistics centers serving e-commerce supply chains',
      'Mixed-use urban regeneration projects with sustainability certifications',
      'Residential portfolios in high-growth metropolitan areas',
      'Sale-leaseback structures with blue-chip corporate tenants',
    ],
  },
  {
    id: 'renewable-energy',
    title: 'Renewable Energy',
    subtitle: 'Utility-scale clean power infrastructure for the zero-carbon transition',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=Expansive%20solar%20farm%20and%20wind%20turbines%20at%20golden%20sunset%2C%20clean%20energy%20infrastructure%2C%20rows%20of%20panels%20and%20turbines%2C%20professional%20landscape%20photography%2C%20warm%20golden%20light%2C%20sustainability%20theme%2C%20bright%20and%20airy&width=1200&height=600&seq=sectors-hero-energy-002&orientation=landscape',
    overview: 'We invest in utility-scale renewable energy assets — solar farms, wind parks, and battery storage facilities — that generate stable, contracted cash flows while accelerating the global energy transition. Our 1.8 GW installed capacity powers over 2 million households and avoids 3.2 million tons of CO₂ annually.',
    stats: [
      { value: '1.8 GW', label: 'Installed Capacity' },
      { value: '15', label: 'Operating Sites' },
      { value: '3.2M Tons', label: 'CO₂ Avoided' },
      { value: '11.8%', label: 'Avg Annual Return' },
    ],
    highlights: [
      '450 MW photovoltaic complex in Andalusia, Spain',
      '320 MW combined onshore/offshore wind in Jutland, Denmark',
      'Grid-scale battery storage facilities (120 MWh capacity)',
      'Long-term power purchase agreements with investment-grade offtakers',
      'Full alignment with EU Taxonomy and SFDR Article 9 requirements',
    ],
  },
  {
    id: 'oil-gas',
    title: 'Oil & Gas',
    subtitle: 'Strategic midstream and downstream energy infrastructure assets',
    icon: 'ri-oil-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20gas%20processing%20facility%20at%20dusk%2C%20clean%20metallic%20infrastructure%2C%20pipelines%20and%20storage%20tanks%2C%20dramatic%20sky%20with%20warm%20amber%20tones%2C%20professional%20industrial%20photography%2C%20energy%20infrastructure%2C%20bright%20highlights&width=1200&height=600&seq=sectors-hero-oilgas-003&orientation=landscape',
    overview: 'Our oil & gas investments focus on midstream and downstream assets with established infrastructure, long-term contracts, and strong cash flow profiles. These strategic positions provide portfolio diversification and inflation-hedging characteristics while generating consistent returns for our investors.',
    stats: [
      { value: '€430M', label: 'Deployed Capital' },
      { value: '8', label: 'Strategic Assets' },
      { value: '4', label: 'Countries' },
      { value: '13.5%', label: 'Avg Annual Return' },
    ],
    highlights: [
      'North Sea gas processing terminal in Rotterdam — 25-year offtake',
      'Trans-Caspian pipeline consortium minority stake',
      'Downstream refining and storage joint ventures',
      'All assets subject to enhanced environmental due diligence',
      'Balanced within broader diversified portfolio framework',
    ],
  },
  {
    id: 'crypto',
    title: 'Crypto & Digital Assets',
    subtitle: 'Institutional-grade exposure to blockchain infrastructure and Web3 ventures',
    icon: 'ri-bit-coin-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20digital%20blockchain%20visualization%20with%20warm%20golden%20holographic%20network%20nodes%2C%20clean%20minimalist%20aesthetic%2C%20premium%20financial%20technology%2C%20amber%20and%20cream%20tones%2C%20professional%20atmosphere&width=1200&height=600&seq=sectors-hero-crypto-004&orientation=landscape',
    overview: 'We provide institutional investors with regulated, risk-managed exposure to the digital asset ecosystem. Our crypto-friendly approach spans blockchain infrastructure, DeFi protocols, and early-stage Web3 ventures — capturing asymmetric upside while maintaining the rigorous risk controls expected of a UK investment firm.',
    stats: [
      { value: '€180M', label: 'Deployed Capital' },
      { value: '12', label: 'Portfolio Companies' },
      { value: '5', label: 'Active Protocols' },
      { value: '20.3%', label: 'Avg Annual Return' },
    ],
    highlights: [
      'Institutional blockchain infrastructure in Crypto Valley, Zug',
      'DeFi liquidity protocol serving institutional market makers',
      'Validator node operations across major proof-of-stake networks',
      'UK-regulated custody and cold storage solutions',
      'Active risk management with real-time portfolio monitoring',
    ],
  },
  {
    id: 'medtech',
    title: 'Medical Equipment',
    subtitle: 'Advanced healthcare technology and medical device manufacturing',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20surgical%20operating%20room%20with%20advanced%20robotic%20surgery%20system%20and%20monitoring%20equipment%2C%20sterile%20clean%20environment%2C%20premium%20healthcare%20technology%2C%20bright%20clinical%20lighting%2C%20professional%20medical%20photography&width=1200&height=600&seq=sectors-hero-medtech-005&orientation=landscape',
    overview: 'Our medical equipment investments target companies developing innovative devices, diagnostic systems, and healthcare technologies that improve patient outcomes. From AI-powered cardiac imaging in Zurich to wearable biosensors in Boston, we back technologies that expand access to quality care while generating strong risk-adjusted returns.',
    stats: [
      { value: '€290M', label: 'Deployed Capital' },
      { value: '9', label: 'Portfolio Companies' },
      { value: '22', label: 'Global Markets' },
      { value: '17.0%', label: 'Avg Annual Return' },
    ],
    highlights: [
      'AI-powered cardiac MRI systems deployed in 140+ hospitals',
      'Surgical robotics platform — FDA and CE certified',
      'Wearable continuous health monitoring with biosensor technology',
      'Regulatory expertise across FDA, CE, and Asian markets',
      'Strong IP portfolios with defensible technological moats',
    ],
  },
];

export default function SectorsPage() {
  return (
    <main>
      {/* Hero */}
      <section className="relative pt-0 pb-0 overflow-hidden">
        {/* Background Image */}
        <div className="relative h-[340px] md:h-[420px] w-full">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20modern%20Swiss%20corporate%20headquarters%20interior%20with%20floor%20to%20ceiling%20glass%20windows%20overlooking%20Zurich%20skyline%2C%20elegant%20minimalist%20boardroom%20with%20marble%20table%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%2C%20professional%20investment%20firm%20atmosphere%2C%20sophisticated%20corporate%20photography%2C%20clean%20architectural%20lines%2C%20bright%20yet%20serious%20tone%2C%20Swiss%20precision%20aesthetic&width=1920&height=600&seq=sectors-hero-serious-2026&orientation=landscape"
            alt="CASA CHERE LIMITED — Investment Sectors"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 w-full">
              <div className="max-w-3xl">
                <span className="text-[10px] uppercase tracking-[3px] text-primary-300 font-semibold">
                  Investment Focus
                </span>
                <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mt-3 mb-5 tracking-tight">
                  Our Sectors
                </h1>
                <p className="text-lg text-white/75 leading-relaxed max-w-2xl font-light">
                  Five diversified pillars, one disciplined investment philosophy. Each sector is selected for its structural growth drivers, cash flow characteristics, and alignment with our UK institutional governance framework.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sector Deep-Dives */}
      {sectors.map((sector, i) => (
        <section
          key={sector.id}
          className={`relative py-20 md:py-28 ${i % 2 === 0 ? 'bg-white' : 'bg-background-50'}`}
        >
          <div className="max-w-[1440px] mx-auto px-6 md:px-12">
            {/* Sector Hero Image */}
            <div className="relative rounded-2xl overflow-hidden mb-14 md:mb-18 h-[300px] md:h-[400px]">
              <img
                src={sector.image}
                alt={sector.title}
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 flex items-center gap-4">
                <div className="w-14 h-14 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center">
                  <i className={`${sector.icon} text-2xl text-primary-600`} />
                </div>
                <div>
                  <h2 className="text-3xl md:text-4xl font-heading font-bold text-white">{sector.title}</h2>
                  <p className="text-white/70 text-sm mt-1">{sector.subtitle}</p>
                </div>
              </div>
            </div>

            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
              {/* Overview */}
              <div className="lg:col-span-2">
                <h3 className="text-xl font-heading font-bold text-foreground-950 mb-4">Overview</h3>
                <p className="text-foreground-500 text-base leading-relaxed mb-8">
                  {sector.overview}
                </p>
                <h3 className="text-xl font-heading font-bold text-foreground-950 mb-4">Key Highlights</h3>
                <ul className="flex flex-col gap-3">
                  {sector.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 shrink-0" />
                      <span className="text-foreground-600 text-sm">{h}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Stats Sidebar */}
              <div>
                <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-foreground-100/20 sticky top-28">
                  <h4 className="text-[10px] uppercase tracking-[3px] text-foreground-400 mb-6">Key Metrics</h4>
                  <div className="flex flex-col gap-6">
                    {sector.stats.map((stat) => (
                      <div key={stat.label}>
                        <p className="text-3xl font-heading font-bold text-foreground-950">{stat.value}</p>
                        <p className="text-xs text-foreground-400 mt-1">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                  <div className="mt-8 pt-6 border-t border-foreground-100/20">
                    <Link
                      to="/portfolio"
                      className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm uppercase tracking-[2px] font-semibold transition-colors cursor-pointer"
                    >
                      View Portfolio
                      <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </main>
  );
}